import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { SalesforceMetaDataServiceImpl } from '../../interfaces/SalesforceMetaDataServiceImpl';
import { BaseMetaDataService } from './base-meta-data.service';

@Injectable({ providedIn: 'root' })
export class SalesforceMetaDataService extends BaseMetaDataService {
  constructor(http: HttpClient) {
    super(http, Namespace.salesforce, new SalesforceMetaDataServiceImpl());
  }
}
